import { useMemo } from 'react';

import { useThemeContext } from '../../theme/context/ThemeContext';
import { field_theme } from '../constants';
import { FieldTheme, FieldThemePartial } from '../types';

export const useFieldTheme = (theme: Partial<FieldThemePartial> = field_theme): FieldTheme => {
  const {
    theme: {
      field: { general, background, color, border },
    },
  } = useThemeContext();

  return useMemo(
    () => ({
      general: { ...general, ...theme.general },
      background: { ...background, ...theme.background },
      border: { ...border, ...theme.border },
      color: { ...color, ...theme.color },
    }),
    [theme, general, background, color, border]
  );
};
